import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    outerContainer: {
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    innerContainer: {
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      borderRadius: '8px',
      minWidth: '100%',
      overflow: 'hidden',
      height: '809px',
      background: 'white',
      padding: '32px 64px 24px 64px',
      justifyContent: 'space-between',
      color: '#2A2A2A',
      flexWrap: 'nowrap',
      [theme.breakpoints.down('lg')]: {
        height: '1620px',
        padding: '32px 20px',
        marginBottom: '16px'
      }
    },
    headingContainer: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 16px 0px',
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 0px 40px',
        width: '100%'
      }
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      width: '100%',
      height: '100%',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column'
      }
    },
    imageAndUpsellsContainer: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      flex: '1 1 50%',
      [theme.breakpoints.down('lg')]: {
        width: '100%'
      }
    },
    upsellContainer: {
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 0px 40px',
        width: '100%'
      }
    },
    imageBox: {
      width: '450px',
      display: 'flex',
      textAlign: 'center',
      height: '500px'
    },
    ticketsTableAndTotalContainer: {
      flex: '1 1 50%'
    },
    ticketsTableContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      width: '100%',
      height: '530px'
    },
    table: {
      width: 'calc(100% - 10px)',
      margin: '0 5px 40px'
    },
    tableRow: {
      display: 'flex',
      alignItems: 'center',
      border: 0,
      width: '100%',
      borderRadius: '8px',
      boxShadow: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
      backgroundColor: '#fff',
      margin: '20px 0',
      padding: '8px 0',
      '&:first-child': {
        margin: '0 0 20px'
      }
    },
    tableBodyCell: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflowWrap: 'anywhere',
      background: '#ffffff00',
      fontSize: '22px',
      border: 0,
      '&:first-child': {
        marginLeft: '15px'
      }
    },
    ticketDetailsTableBodyCell: {
      width: '280px'
    },
    ticketPriceTableBodyCell: {
      flex: '0 0 150px',
      justifyContent: 'flex-end',
      display: 'flex'
    },
    removeTableBodyCell: {
      flex: '0 0 80px',
      justifyContent: 'center',
      display: 'flex'
    },
    numberTableBodyCell: {
      textAlign: 'right'
    },
    portraitManualEntryButtonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '20px'
    },
    portraitManualEntryButtonBox: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0px 10px',
        margin: '20px 0px'
      }
    },
    manualEntryButtonBox: {
      flex: 'none',
      background: 'transparent',
      display: 'block',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    totalAmountDivider: {
      height: '1px',
      background: '#9B9B9B',
      color: 'white',
      minWidth: '100%',
      margin: '24px 0 16px'
    },
    totalAmountContainer: {
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      background: 'transparent',
      flexWrap: 'wrap',
      [theme.breakpoints.down('lg')]: {
        padding: '0 10px'
      }
    },
    manualEntryOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    manualEntryInnerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      alignItems: 'start',
      justifyContent: 'center',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        height: '1640px'
      }
    },
    manualEntryHeadingDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        height: '1385px'
      }
    },
    manualEntrySubheader: {
      textAlign: 'center',
      fontSize: '30px',
      [theme.breakpoints.down('lg')]: {
        width: '612px',
        padding: '0px'
      }
    },
    manualEntryInputFieldDiv: {
      width: '932px',
      background: 'transparent',
      margin: '30px 0px 64px 0px',
      [theme.breakpoints.down('lg')]: {
        width: '822px',
        margin: '16px 0px 64px 0px'
      }
    }
  })
);
